<header class="site-header">
  <div class="header-container">
    <div class="header-left">
      <a routerLink="/" class="logo-link">
        <img [src]="logoPath" alt="Cargo Logo" class="logo" />
      </a>
      
      <!-- Навигация по лендингу (для гостей; у вошедших — меню кабинета) -->
      <nav *ngIf="!isAuthenticated" class="site-nav" [attr.aria-label]="t('footer.product')">
        <a href="/#sol" (click)="goToSection($event, 'sol')">{{ t('footer.features') }}</a>
        <a href="/#tar" (click)="goToSection($event, 'tar')">{{ t('footer.tariffs') }}</a>
        <a href="/#cases" (click)="goToSection($event, 'cases')">{{ t('footer.cases') }}</a>
      </nav>

      <div *ngIf="isAuthenticated" class="user-menu">
        <a *ngIf="isCargoOwner" routerLink="/cargo-owner/dashboard" class="menu-link">
          {{ myRequestsText }}
        </a>
        <a *ngIf="isFreightForwarder" routerLink="/freight-forwarder/dashboard" class="menu-link">
          {{ personalCabinetText }}
        </a>
        <a *ngIf="isCustomsBroker" routerLink="/customs-broker/dashboard" class="menu-link">
          {{ personalCabinetText }}
        </a>
        <a *ngIf="isPublic" routerLink="/public/dashboard" class="menu-link">
          {{ personalCabinetText }}
        </a>
        <a *ngIf="isAdmin" routerLink="/admin/users" class="menu-link">
          {{ usersText }}
        </a>
      </div>
    </div>
    
    <div class="header-right">
      <div class="currency-rates">
        <div class="currency-item" *ngFor="let code of currencyCodes">
          <span class="currency-flag" aria-hidden="true" [ngSwitch]="code">
            <svg *ngSwitchCase="'USD'" viewBox="0 0 24 24" width="18" height="18">
              <defs><clipPath id="flag-us"><circle cx="12" cy="12" r="12"/></clipPath></defs>
              <g clip-path="url(#flag-us)">
                <rect width="24" height="24" fill="#fff"/>
                <rect y="0" width="24" height="3.4" fill="#d22f3c"/>
                <rect y="6.9" width="24" height="3.4" fill="#d22f3c"/>
                <rect y="13.7" width="24" height="3.4" fill="#d22f3c"/>
                <rect y="20.6" width="24" height="3.4" fill="#d22f3c"/>
                <rect width="13" height="13.7" fill="#3c3b6e"/>
                <g fill="#fff"><circle cx="3.5" cy="3.5" r="0.9"/><circle cx="7" cy="3.5" r="0.9"/><circle cx="10.5" cy="3.5" r="0.9"/><circle cx="5.2" cy="7" r="0.9"/><circle cx="8.8" cy="7" r="0.9"/><circle cx="3.5" cy="10.5" r="0.9"/><circle cx="7" cy="10.5" r="0.9"/><circle cx="10.5" cy="10.5" r="0.9"/></g>
              </g>
            </svg>
            <svg *ngSwitchCase="'EUR'" viewBox="0 0 24 24" width="18" height="18">
              <circle cx="12" cy="12" r="12" fill="#1f4aa8"/>
              <g fill="#ffcc00">
                <circle cx="12" cy="5" r="1.1"/><circle cx="15.5" cy="5.9" r="1.1"/><circle cx="18.1" cy="8.5" r="1.1"/>
                <circle cx="19" cy="12" r="1.1"/><circle cx="18.1" cy="15.5" r="1.1"/><circle cx="15.5" cy="18.1" r="1.1"/>
                <circle cx="12" cy="19" r="1.1"/><circle cx="8.5" cy="18.1" r="1.1"/><circle cx="5.9" cy="15.5" r="1.1"/>
                <circle cx="5" cy="12" r="1.1"/><circle cx="5.9" cy="8.5" r="1.1"/><circle cx="8.5" cy="5.9" r="1.1"/>
              </g>
            </svg>
            <svg *ngSwitchCase="'CNY'" viewBox="0 0 24 24" width="18" height="18">
              <circle cx="12" cy="12" r="12" fill="#de2910"/>
              <path fill="#ffde00" d="M7 4.2l1.1 3.3h3.4L8.8 9.6l1 3.2L7 10.8l-2.8 2 1-3.2L2.5 7.5h3.4z"/>
              <g fill="#ffde00"><circle cx="13" cy="4.6" r="0.9"/><circle cx="15" cy="7" r="0.9"/><circle cx="15" cy="10" r="0.9"/><circle cx="13" cy="12.2" r="0.9"/></g>
            </svg>
          </span>
          <span class="currency-label">{{ code }}:</span>
          <span class="currency-value">{{ rates[code] | number:'1.2-2' }}</span>
        </div>
      </div>

      <div class="header-actions">
        <a
          class="whatsapp-link"
          [href]="whatsappHref"
          target="_blank"
          rel="noopener noreferrer"
          [attr.aria-label]="whatsappLabel"
          [title]="whatsappLabel"
        >
          <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor" aria-hidden="true">
            <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.39 1.26 4.82L2 22l5.4-1.42a9.9 9.9 0 0 0 4.64 1.18h.01c5.46 0 9.91-4.45 9.91-9.91C21.96 6.45 17.5 2 12.04 2zm5.8 14.1c-.24.68-1.4 1.3-1.93 1.38-.49.08-1.11.11-1.79-.11-.41-.13-.94-.3-1.62-.6-2.86-1.24-4.72-4.12-4.86-4.31-.14-.19-1.16-1.54-1.16-2.94 0-1.4.73-2.08.99-2.37.26-.28.57-.35.76-.35.19 0 .38 0 .55.01.17.01.41-.07.64.49.24.58.81 2 .88 2.14.07.14.12.31.02.5-.1.19-.15.31-.29.48-.14.17-.3.37-.43.5-.14.14-.29.29-.13.57.17.28.74 1.22 1.58 1.98 1.09.97 2 1.27 2.29 1.41.29.14.46.12.63-.07.17-.19.72-.84.92-1.13.19-.28.38-.24.64-.14.26.1 1.67.79 1.95.93.29.14.48.21.55.33.07.12.07.68-.17 1.36z"/>
          </svg>
        </a>

        <app-notification-bell *ngIf="isAuthenticated"></app-notification-bell>

        <div class="language-switcher">
          <button type="button" class="lang-toggle" (click)="toggleLangMenu()">
            {{ currentLanguageLabel }}
            <svg class="lang-toggle__chevron" [class.open]="langMenuOpen" width="12" height="12" viewBox="0 0 24 24" fill="none">
              <path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
          <div class="lang-menu" *ngIf="langMenuOpen">
            <button
              *ngFor="let lang of languageOptions"
              type="button"
              class="lang-menu__item"
              [class.active]="currentLanguage === lang.code"
              (click)="selectLanguage(lang.code)"
            >
              {{ lang.label }}
            </button>
          </div>
        </div>
      
        <a *ngIf="!isAuthenticated" routerLink="/login" class="login-button">
          {{ loginText }}
        </a>
      
        <button 
          *ngIf="isAuthenticated"
          (click)="goToProfile()" 
          class="profile-button"
          type="button"
          [title]="currentUser?.fullName || ''"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M20.59 22C20.59 18.13 16.74 15 12 15C7.26 15 3.41 18.13 3.41 22" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
    </div>
  </div>
</header>

